import React, {useState} from 'react';
import Arrow from '../../assets/images/arrow.svg';
import { useHistory } from 'react-router';
import 'react-toastify/dist/ReactToastify.css';
import Logo from '../../assets/images/EZ_LEISURE_LOGO.svg';
import { ToastContainer, toast } from 'react-toastify';
import { 
  EmailValidation, 
  PhoneValidation
} from '../../utils/Validation.js';
import { Put} from '../../Api/ApiMethods.js';
import { 
  forgetPasswordGetOtpUrl
 } from '../../Routes/ApiRoutes';
 import iconEmailClear from '../../assets/images/emailClear.svg';

export default function ForgetPassword() {
  const history = useHistory();
  const [emailError, setEmailError] = useState(null);
  const [obj ,setObj] = useState({
    "contact": ''
  });

  var handleEmailsInput = (e) => {
    let updatedDetails = { ...obj };
    updatedDetails[e.target.id] = e.target.value;
    setObj(updatedDetails);

    if(EmailValidation(e.target.value) || PhoneValidation(e.target.value))
    {
       setEmailError(null);
    }
    else{
     setEmailError('Invalid email/phone');
    }
   }

  const handleChangePassword = () => {
    if(obj.contact === '')
    {
      setEmailError('Email/Phone can not be blank')
    }
    if(obj.contact !== '' && !(emailError))
    {
    try {
        Put(forgetPasswordGetOtpUrl, obj)
        .then(response => {
            if(response.status === 200)                
            {
              toast.success(response.message)
              setTimeout(() => 
                history.push({ 
                pathname: '/verifyRPO',
                state : obj
                }), 2100)
            }
        })
        .catch(error => {
          toast.error(error.error)
        })
      }catch (error) {
        console.log(error);
      }
    }
}

    return (<>
        <section className="header">
            <div className="container">
                <nav className="navbar navbar-expand-lg navbar-light bg-light login-header">
                <a className="navbar-brand" href="#">
                    <img className="img-fluid" src={Logo} />
                </a>
                </nav>
            </div>
            <ToastContainer position="top-center" autoClose={2000}/>
        </section>
        <section class="sign-in-wrapper Forgot-Wpassword">
            <div class="container">
              <div class="sign-in">
                <h3> <img onClick={() => history.push(`/login`)} src={Arrow} />
                  <span>Forgot Password</span>
                </h3>
                <p>Please enter the email address or phone number you used to create your account 
                  and we’ll send an OTP to you for reset your password</p>
          
                <div className="form-group">
                  <img className='inputImage' style={{visibility : obj.contact === '' ? 'hidden' : 'visible'}} 
                      alt='emailClear' src={iconEmailClear} onClick={() => {
                        let updatedDetails = { ...obj };
                        updatedDetails['contact'] = '';
                        setObj(updatedDetails)
                        setEmailError(null);
                    }} />
                  <input autoComplete='off' onChange={(e) => handleEmailsInput(e)} 
                  value={obj.contact} id='contact' type="text" className={emailError ? "form-control borderRed" : "form-control" } placeholder="Email/Phone" />
                  {emailError && <span className='form-error'>{emailError}</span>}
                </div>
           
                <div class="comman-btn">
                  <button onClick={handleChangePassword}>Next</button>
                </div> 
              </div>
            </div>
          </section>
    </>)
}
